import { ToggleComponent } from '../../../../../../featureToggle';
import GroupUserAssign from './GroupUserAssign';
import GroupUserAssignStoerkId from './GroupUserAssignStoerkId';

export default ToggleComponent(GroupUserAssign, {
  stoerkId: GroupUserAssignStoerkId,
});
